import { Component, OnInit, TemplateRef} from '@angular/core';
import { Cliente } from '../../../models/cliente';
import { ClienteService } from '../../../services/cliente.service';
import { ClienteModalComponent } from '../../modals/cliente-modal/cliente-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Bodega } from '../../../models/bodega';
import { BodegaService } from '../../../services/bodega.service';
import { SessionService } from '../../../services/session.service';
import { PlanAcumulativo } from '../../../models/plan-acumulativo';
import * as moment from 'moment';
import { SweetMessage } from '../../../config/sweet-message';
import { ProductoPrecioModalComponent } from '../../modals/producto-precio-modal/producto-precio-modal.component';
import { PlanAcumulativoDetalle } from '../../../models/plan-acumulativo-detalle';
import { Validation } from '../../../config/validation';
import { TipoDocumento } from '../../../models/tipo-documento';
import { TipoComprobanteService } from '../../../services/tipo-comprobante.service';
import { ParametroService } from '../../../services/parametro.service';
import { PreciosModalComponent } from '../../modals/precios-modal/precios-modal.component';
import { PrecioAdicional } from '../../../models/precio_adicional';
import { PlanAcumulativoService } from '../../../services/plan-acumulativo.service';
import { ConfirmacionAnulacionModalComponent } from '../../modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { ProductoService } from '../../../services/producto.service';

@Component({
  selector: 'app-plan-acumulativo-edit',
  templateUrl: './plan-acumulativo-edit.component.html',
  styleUrls: ['./plan-acumulativo-edit.component.css'],
  providers: [
	  ClienteService,
	  BodegaService,
	  TipoComprobanteService,
	  ParametroService,
	  PlanAcumulativoService,
	  ProductoService
	]
})
export class PlanAcumulativoEditComponent implements OnInit {
	public cliente: Cliente;
	public loading: boolean;
	public bsModalRef: BsModalRef;
	public bodegas: Array<Bodega>;
	public plan: PlanAcumulativo;
	public fecha_caducidad;
	public fecha_MesAnt;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public tipos: Array<TipoDocumento>;
	public Identif: string;
	public Mod_FactElec: string;
	public Mod_Inventario: string;
	public IVA: number;
	public IVA_PARAM: number;
	public is_precios: boolean;
	public detalle: String;
	public plan_detalle: PlanAcumulativoDetalle;
	public PreciosAdd: PrecioAdicional;
	public SECUENCIAL: number;
	public is_precio_unitario_editable: boolean;
	public detalles:Array<PlanAcumulativoDetalle>;
	public add: Boolean;
	public delete: Boolean;
	public cantidad_excedida: Boolean;
	public openProduct :Boolean;
	public plan_id:PlanAcumulativo;

  constructor(
    public clienteService: ClienteService,
    private modalService: BsModalService,
    public bodegaService: BodegaService,
    public ss: SessionService,
    public tipoComprobanteService: TipoComprobanteService,
    private parametroService: ParametroService,
	private planAcumulativoService: PlanAcumulativoService,
	private productoService: ProductoService,
    private storage: AsyncLocalStorage,
  ) {
    this.cliente = new Cliente();
    this.loading = false;
	this.bodegas = [];
	this.detalles = [];
    this.plan = new PlanAcumulativo();
    this.fecha_caducidad = moment(this.fecha_caducidad);
    this.fecha_MesAnt = moment(this.fecha_MesAnt);
    this.msgSweet = new SweetMessage();
	this.vl = new Validation();
	this.IVA = 0;
	this.IVA_PARAM = 0;
	this.add = false;
	this.delete = false;
	this.cantidad_excedida = false;
	this.openProduct = true;
	this.plan_id = new PlanAcumulativo();
   
    this.Mod_FactElec = this.ss.getData("mod_felectronica");
	this.Mod_Inventario = this.ss.getData("mod_inventario");
	this.is_precio_unitario_editable = false;
    
  }

	ngOnInit() {
		// this.openProduct = true;
		let p1 = this.getAll();
		let p2 = this.getIVA();
		let p3 = this.getPreciosAdicionales();
		let p4 = this.getPrecioUnitarioEditable();
		Promise.all([p1,p2,p3,p4]).then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	getAll(){
		this.storage.getItem("plan-acumulativo").subscribe(data => {
			this.plan_id = data.id;
			this.getPlanById();
		});
	}
	
	getPlanById(){
        this.loading = true;
        let qs = '?embed=tipocomprobante,cliente,bodega,detalle?embed=producto';
        this.planAcumulativoService.getById(this.plan_id, qs).subscribe(
            res => {
                this.loading = false;
				this.plan = res.data;
		
                this.plan.detalle.forEach(item => {
                    let qs = "?embed=unidadmedida";
                    this.productoService.getById(item.producto.id, qs).subscribe(
                        res=>{
                        item.producto = res;
                        },
                        err=>{
                        this.loading = false;
                        }
                    )
				});
            },
            err => {
                this.loading = false;
            }
        );
    }

	getIVA(){
		return new Promise((resolve, reject) => {
			this.parametroService.getById(1).subscribe(
				res => {
                    this.IVA = parseFloat(res.valor) / 100;
                    this.IVA_PARAM = res.valor;
					resolve();
				},
				err => {
                    this.IVA = 0;
                    this.IVA_PARAM = 0;
					reject(err);
				}
			);
		});
	}

	onSubmit(){
		this.cantidad_excedida = false;

		this.plan.total = (parseFloat(this.plan.total.toString()));
		this.plan.abonado = (parseFloat(this.plan.abonado.toString()));
		if (this.plan.total < this.plan.abonado) {
			this.msgSweet.showMessage('error-message', 'El total del plan no debe ser menor que lo abonado');
			this.cantidad_excedida = true;
		}else{
			let preg = "¿Está seguro de editar el plan acumulativo?";
			const initialState = { Pregunta: preg, Respuesta:false };
			this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));
			
			
			this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
				if( Respuesta == true ){
					this.loading = true;
					// this.setValueEntity();
					// if (this.add || this.delete) {
						this.planAcumulativoService.edit(this.plan).subscribe(
							res => {
								this.openProduct = false;
								this.plan = new PlanAcumulativo();
								this.plan_detalle = new PlanAcumulativoDetalle();
								this.cliente = new Cliente();
								this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
								this.loading = false;
								// this.openProduct = true;
								// this.getSecuencial().then(
								// 	res => this.loading = false,
								// 	err => this.loading = false,
								// );
							},
							err => {
								this.msgSweet.showMessage('error-message',err);
								this.loading = false;
							}
						);
					// } else {
					// 	this.openProduct = false;
					// 	this.loading = true;
					// 	this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
					// 	this.plan = new PlanAcumulativo();
					// 	this.plan_detalle = new PlanAcumulativoDetalle();
					// 	this.cliente = new Cliente();
					// 	this.loading = false;
					// }
					
				}
			});
		}

		
	}
  
	onSearchProducto() {
		this.openProduct = true;
		const initialState = {bodega_id: this.plan.bodega_id};
		this.bsModalRef = this.modalService.show(ProductoPrecioModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));

		this.bsModalRef.content.sendProductoPrecio.take(1).subscribe((value) => {
			//this.sendObjectProducto(value);
			this.addProduct(value);
		});
	}
  
  	addProduct(value){
		let plan_detalle = new PlanAcumulativoDetalle();

		plan_detalle.producto_id = value.id;
		plan_detalle.producto.codigo = value.codigo;
		plan_detalle.producto.nombre = value.nombre;
		plan_detalle.cantidad_stock = value.cantidad_stock;
		plan_detalle.producto.graba_iva = value.graba_iva;
		plan_detalle.producto.unidadmedida.nombre = value.unidad;
		plan_detalle.precio_unitario = parseFloat(value.precio);
		plan_detalle.cantidad = 1;
		plan_detalle.subtotal = plan_detalle.cantidad * plan_detalle.precio_unitario;

		if( parseInt(this.plan.tipo_comprobante_id.toString()) === 1 || parseInt(this.plan.tipo_comprobante_id.toString()) === 4 ){
			if( value.graba_iva === 0 ){
				plan_detalle.iva = 0;
				plan_detalle.porct_iva = 0;
			}else{
				plan_detalle.iva = plan_detalle.subtotal * this.IVA;
				plan_detalle.porct_iva = this.IVA_PARAM;
			}
		}else{
			plan_detalle.iva = 0;
			plan_detalle.porct_iva = 0;
		}
		plan_detalle.total = plan_detalle.iva + plan_detalle.subtotal;
		
		plan_detalle.usuario_id = this.ss.getData('usuario_id');
		plan_detalle.empresa_id = this.ss.getData('empresa_id');
		plan_detalle.sucursal_id = this.ss.getData('sucursal_id');
		
		this.plan.detalle.push(plan_detalle);
		
		this.calcularTotales();
		this.add = true;
		this.cantidad_excedida =false;
		

	}

	getPrecioUnitarioEditable(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_unitario_editable_id = 18;
            this.parametroService.getById(precio_unitario_editable_id).subscribe(
                res => {
				
                    this.is_precio_unitario_editable = (res.valor.toString().trim() === "1");
                    resolve();
                },
                err => {
                    this.is_precio_unitario_editable = false;
                    reject(err);
                }
            );
        });
    }

	openModalPrecios(plan_detalle: PlanAcumulativoDetalle){
        const initialState = { producto_id: plan_detalle.producto_id, descripcion: plan_detalle.producto.nombre};
        this.bsModalRef = this.modalService.show(PreciosModalComponent, Object.assign({backdrop: 'static'}, {class: 'modal-sm', initialState}));

        this.bsModalRef.content.sendPrecio.take(1).subscribe((precio) => {
            this.PreciosAdd = precio;

            plan_detalle.precio_unitario = parseFloat(this.PreciosAdd.valor.toString());
			plan_detalle.subtotal = (plan_detalle.cantidad * plan_detalle.precio_unitario) - plan_detalle.desc_valor;

            this.calcularTotales();
        });
	}
	
	getPreciosAdicionales(){
        // VALORES RESPONSE: SI, NO
        return new Promise((resolve, reject) => {
            let precio_adicional_id = 16;
            this.parametroService.getById(precio_adicional_id).subscribe(
                res => {
                    this.is_precios = (res.valor.toString().trim() === "SI");
                    resolve();
                },
                err => {
                    this.is_precios = false;
                    reject(err);
                }
            );
        });
	}

	onDelete(i) {
		this.plan.detalle.splice(i, 1);
		//this.calcularFactura();
		this.calcularTotales();
		this.delete = true;
	}

	calcularTotales(){
		this.plan.subtotal_iva12 = 0;
		this.plan.subtotal_iva0 = 0;
		this.plan.subt_desct_iva12 = 0;
		this.plan.subt_desct_iva0 = 0;
		this.plan.subt_desct_iva0 = 0;
		this.plan.subt_desct_iva12 = 0;
		this.plan.desc_valor = 0;
		this.plan.iva = 0;
		this.plan.total = 0;
		let tipo_comprobante_id = parseInt(this.plan.tipo_comprobante_id.toString());
		let descuento = 0;
		this.plan.detalle.forEach(obj => {
				descuento += parseFloat(obj.desc_valor.toString());
				if( (tipo_comprobante_id === 1 && obj.producto.graba_iva) || tipo_comprobante_id === 4 && obj.producto.graba_iva ){
					 this.plan.subtotal_iva12 +=  parseFloat (obj.subtotal.toString());
					
				}else{
					this.plan.subtotal_iva0 += parseFloat(obj.subtotal.toString());
			
				}
			});
			this.plan.desc_valor = descuento;

		if( tipo_comprobante_id === 1 || tipo_comprobante_id === 4 ){
			
			this.plan.iva = parseFloat((Math.round((this.plan.subtotal_iva12 * this.IVA) * 100) / 100).toString());
			parseFloat(this.plan.iva.toString());
			
		}else{
			this.plan.iva = Math.round(this.plan.subtotal_iva12 * 100) / 100;
			parseFloat(this.plan.iva.toString());
			
			
		}
			
			this.plan.total = this.plan.subtotal_iva12 + this.plan.subtotal_iva0 + this.plan.iva;
			
			
			
		
	}
	
	openModalDetalle(template: TemplateRef<any>, plan_detalle) {
        this.detalle = plan_detalle.detalle;
        this.plan_detalle = plan_detalle;
        this.bsModalRef = this.modalService.show(template);
	}
	
	saveDetalle(){
        this.plan_detalle.detalle = this.detalle.toString().trim();
        this.detalle  = "";
        this.bsModalRef.hide();
	}

	isValidForm(){
		// if( this.SECUENCIAL == 0 ){
		// 	return false;
		// }
		// if( this.plan.tipo_comprobante_id == "" ){
		// 	return false;
		// }
		// if( this.plan.bodega_id == "" ){
		// 	return false;
		// }
		// if( this.cliente.id == "" ){
		// 	return false;
		// }
		if( this.plan.detalle.length == 0 ){
			return false;
		}
		if(this.cantidad_excedida){
			return false;
		}
		// if (this.openProduct) {
		// 	return false;
		// }
		return true;
	}

	verificationValue(event, plan_detalle: PlanAcumulativoDetalle, campo: string){
        if( event.target.value.trim().length === 0 ){
            if( campo === 'cantidad' ){
                plan_detalle[campo] = 1;
            }else{
                plan_detalle[campo] = 0;
            }
        }
	}
	
	changeValue(event, plan_detalle: PlanAcumulativoDetalle, campo: string){
        let dscto_valor = plan_detalle.desc_valor;
        //let dscto_porcent = plan_detalle.desc_porcent;
        let value = event.target.value;

        plan_detalle[campo] = value;

        /*if( campo === 'desc_porcent' ){
            if( plan_detalle[campo] > 100 ){
                plan_detalle[campo] = 100;
            }
		}*/

        let subtotal = (plan_detalle.cantidad * plan_detalle.precio_unitario) - plan_detalle.desc_valor;
        //let porcent_value = subtotal * (plan_detalle.desc_porcent / 100)
		//plan_detalle.subtotal = subtotal - porcent_value;
		plan_detalle.subtotal = subtotal;

		if( parseInt(this.plan.tipo_comprobante_id.toString()) === 1 || parseInt(this.plan.tipo_comprobante_id.toString()) === 4 ){
			if( plan_detalle.producto.graba_iva == false ){
				plan_detalle.iva = 0;
				plan_detalle.porct_iva = 0;
			}else{
				plan_detalle.iva = plan_detalle.subtotal * this.IVA;
				plan_detalle.porct_iva = this.IVA_PARAM;
			}
		}else{
			plan_detalle.iva = 0;
			plan_detalle.porct_iva = 0;
		}

		plan_detalle.total = plan_detalle.iva + plan_detalle.subtotal;
		
		//this.calcularFactura();
		this.calcularTotales();
		this.cantidad_excedida = false;
	}
	
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/plan-acumulativo-edit/plan-acumulativo-edit.component.ts